
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.multistep-card{
  width:430px;
}
.multistep-card a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}
.card-number__button {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  height: 5rem;
  width: 5rem;
  border-radius: 9999px;
  border-width: 0px;
  background-color: var(--blue-responsible-main);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 48px;
  font-weight: var(--fw-bold);
  color: var(--neutral-white);
}
.card-title {
  text-align: center;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  font-weight: var(--fw-bold);
  color: var(--neutral-white);
  display: flex;
  height: 5rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: var(--blue-responsible-main);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.card-title-container{
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:2;
  -webkit-box-orient:vertical;
}
.card-summary {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.card-panel {
  display: none;
  padding-left: 1.75rem;
  padding-right: 1.75rem;
  padding-bottom: 1.75rem;
}
::slotted(idb-styled-text) {
  color: var(--gray-professional-lighten-1);
}
.multistep-card--open .card-content{
  border-radius:10px;
  box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.25);
  margin-top: 1.75rem;
}
.multistep-card--open .card-panel {
  display: block;
}
.multistep-card--first .card-title{
  border-radius:20px 0px 0px 20px;
}
.multistep-card--last .card-title{
  border-radius:0px 20px 20px 0px;
}
.multistep-card--single .card-title{
  border-radius:20px;
}
`;